import React from 'react';
import AddLanguageComponent from '../../../Components/Language/AddLanguage';

export default function AddLanguage() {
    return (
        <div className='page-body'>
            <AddLanguageComponent />
        </div>
    );
}